/**
 * Value for POST /comply/tppvalidationV2 order_headers_ID / order_number.
 * Cerpass1 orders are numeric. Salesforce orders are APP-… strings.
 * Number("APP-…") is NaN, and JSON.stringify turns NaN into null, which the API rejects.
 */
export function orderIdForTppValidation(order) {
  const orderNumber =
    order?.orderNumber != null ? String(order.orderNumber).trim() : '';
  if (/^APP-/i.test(orderNumber)) {
    return orderNumber;
  }

  const headersId =
    order?.orderHeadersId != null ? String(order.orderHeadersId).trim() : '';
  if (/^\d+$/.test(headersId)) {
    return Number(headersId);
  }
  if (/^\d+$/.test(orderNumber)) {
    return Number(orderNumber);
  }
  return orderNumber || undefined;
}
